import {
  OTP_GENERATE,
  OTP_VALIDATE,
  WORK_EMAIL_VALIDATE,
  PERSONAL_EMAIL_VALIDATE,
  DECISION,
  COMPANIES,
  SEND_FORM_DATA,
  //Begin Code modified by Attra for Release 1.0
  GET_CIF,
  CIF_UPDATE,
  LEAD_CREATION,
  INCOME_UPDATE,
  CREDIT_SCORE_CALCULATION,
  CREDIT_REPORT,
  SR_CREATE,
  LEAD_SQUARDED,
  PROMO_CODE,
  BRANCH_DETAILS,
  //End Code modified by Attra for Release 1.0
  CREDIT_SCORE,
  START_TRANSACTION,
  END_TRANSACTION,
  MONTHLY_INSTALMENT,
  INSTITUTIONS,
  SEND_BANK_STATEMENT,
  IDENTITY_VERIFICATION,


} from '@/forms/constants/services';
import { SET_RESPONSE_PARAMS } from '@/lib/constants/mutations';
import {
  RESPONSE_TYPES,
  DECISION_RESPONSE_VALUES,
  OTP_VALIDATE_VALUES,
  CREDIT_APPROVED_VALUES,
} from './constants';

export default {
  props: {
    model: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      services: [
        {
          serviceName: DECISION,
          responseValue: this.defaultValueLabel(DECISION_RESPONSE_VALUES),
          responseValues: DECISION_RESPONSE_VALUES,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: COMPANIES,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: SEND_FORM_DATA,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: OTP_GENERATE,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: OTP_VALIDATE,
          responseDelay: 0,
          responseValue: this.defaultValueLabel(OTP_VALIDATE_VALUES),
          responseValues: OTP_VALIDATE_VALUES,
          responseType: 'ok',
          useMockServer: false,
        },

        {
          serviceName: WORK_EMAIL_VALIDATE,
          responseDelay: 0,
          responseValue: this.defaultValueLabel(WORK_EMAIL_VALIDATE),
          responseValues: WORK_EMAIL_VALIDATE,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: PERSONAL_EMAIL_VALIDATE,
          responseDelay: 0,
          responseValue: this.defaultValueLabel(PERSONAL_EMAIL_VALIDATE),
          responseValues: PERSONAL_EMAIL_VALIDATE,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: CREDIT_SCORE,
          responseDelay: 0,
          responseType: 'ok',
          responseValue: this.defaultValueLabel(CREDIT_APPROVED_VALUES),
          responseValues: CREDIT_APPROVED_VALUES,
          useMockServer: false,
        },
        {
          serviceName: MONTHLY_INSTALMENT,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: START_TRANSACTION,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: END_TRANSACTION,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: INSTITUTIONS,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: SEND_BANK_STATEMENT,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: IDENTITY_VERIFICATION,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        //added by ATTRA for Release 1.0 on 10-Oct-2019
        {
          serviceName: GET_CIF,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: CIF_UPDATE,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: LEAD_CREATION,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: INCOME_UPDATE,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: CREDIT_REPORT,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: CREDIT_SCORE_CALCULATION,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: SR_CREATE,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: LEAD_SQUARDED,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: PROMO_CODE,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        {
          serviceName: BRANCH_DETAILS,
          responseDelay: 0,
          responseType: 'ok',
          useMockServer: false,
        },
        
        //end ATTRA
      ],
      responseTypes: RESPONSE_TYPES,
      showPanel: false,
      store: this.model,
    };
  },

  computed: {
    indicatorType() {
      return this.showPanel ? '-' : '+';
    },
  },

  methods: {
    onResponseSelected(service) {
      let { responseValue } = service;
      if (responseValue) {
        responseValue = this.getResponseValue(service.responseValues, service.responseValue);
      }

      this.store.commit(SET_RESPONSE_PARAMS, {
        ...service,
        responseValue,
      });
    },

    defaultValueLabel(values) {
      return values[0].label;
    },

    getResponseValue(options, selectedLabel) {
      return options.filter(option => option.label === selectedLabel)[0].value;
    },
  },

  mounted() {
    this.services.forEach((service) => {
      this.onResponseSelected(service);
    });
  },
};
